module.exports = __webpack_public_path__ + "a0e60d6543e02a81b6b5dc00f643cf48.svg";